const init = (settings) => {
  $(document).ready(function() {



    const accordion = $('[js-accordion]');
    const classOpen = 'open';


    if (accordion.length) {
      accordion.on('click', function () {
        let target = $(this).next();

        if ($(this).hasClass(classOpen)) {
          // $(this).removeClass(classOpen);
          $(accordion).removeClass(classOpen);
          $(accordion).next().slideUp(300);
          target.slideUp(300);
        }
        else {
          $(accordion).removeClass(classOpen);
          $(this).addClass(classOpen);
          $(accordion).next().slideUp(300);
          target.slideDown(300);
        }
      });
    }


  });
};

export default {
    init
}
